<template>
  <div class="timeList">
    <div v-for="(item, index) in yearList" :key="index">
      <h2>{{ index.substring(4) }}</h2>
      <ul>
        <li v-for="(article, idx) in item" :key="idx">
          <div class="date">{{ article.date.substring(5, 10) }}</div>
          <div
            class="title"
            @click="toArticlePage(article.ID)"
            v-html="article.mainTitle"
          ></div>
          <div class="tags">
            <span class="item" v-for="(tag, i) in article.tags" :key="i">{{
              tag
            }}</span>
          </div>
        </li>
      </ul>
    </div>
    <div class="error-wrapper">
      <v-Loading v-show="isLoading"></v-Loading>
      <v-ErrorCom
        v-if="!isLoading && !Object.keys(yearList).length"
      ></v-ErrorCom>
    </div>
    <li
      v-if="
        currentPage !== allPageNum && !isLoading && Object.keys(yearList).length
      "
      style="text-align:center;padding:30px 0;color:'#666666'"
    >
      上拉滑动查看更多
    </li>
    <li
      v-if="
        currentPage == allPageNum && !isLoading && Object.keys(yearList).length
      "
      style="text-align:center;padding:30px 0;color:'#666666'"
    >
      我是有底线的 (¯^¯ )
    </li>
  </div>
</template>

<script>
import ErrorCom from "@/components/common/error/error";
import Loading from "@/components/common/loading/loading";
export default {
  components: {
    "v-ErrorCom": ErrorCom,
    "v-Loading": Loading
  },
  props: {
    yearList: {
      type: Object
    },
    articleCount: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageNum: {
      type: Number,
      default: 10
    },
    isLoading: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    //总页面数
    allPageNum() {
      return Math.ceil(this.articleCount / this.pageNum);
    }
  },
  methods: {
    toArticlePage(id) {
      const userId = this.$route.query.userId;
      if (userId === undefined) {
        this.$router.push({ path: "/article", query: { articleId: id } });
      } else {
        this.$router.push({
          path: "/article",
          query: { userId: userId, articleId: id }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../assets/style/common.less";
@m26a69a: #26a69a;
.timeList {
  width: 75%;
  height: 101vh;
  padding: 0 20px;
  padding-top: 20px;
  h2 {
    font-size: 22px;
  }
  ul {
    margin: 20px 0 0 30px;
    li {
      line-height: 25px;
      padding-bottom: 10px;
      font-family: "sourcesanspro", "Helvetica Neue", Arial, sans-serif;
      .clearfixMixin();
      .date {
        float: left;
        margin-right: 30px;
        color: #919d9e;
      }
      .title {
        color: #616969;
        cursor: pointer;
        transition: all 0.3s;
        &:hover {
          color: @m26a69a;
          transform: translateX(8px);
        }
      }
      .tags {
        float: right;
        .item {
          display: inline-block;
          padding: 0 8px;
          margin-right: 5px;
          font-size: 12px;
          line-height: 18px;
          border: 1px solid #5bc2b8;
          color: #5bc2b8;
          border-radius: 10px;
          transition: all 0.2s;
          cursor: pointer;
          &:hover {
            background-color: #5bc2b8;
            color: #fff;
          }
        }
      }
    }
  }
}
@media (max-width: 1024px) {
  .timeList {
    width: 100%;
    box-sizing: border-box;
    ul {
      margin: 20px 0 0;
      li {
        .title {
          width: 80%;
          float: right;
          word-break: break-all;
        }
        .tags {
          display: none;
        }
        .date {
          margin: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// timeList.vue?67d5c7d2